import { render } from "./ConvalidaModifiche.vue?vue&type=template&id=1c15b07c&scoped=true"
import script from "./ConvalidaModifiche.vue?vue&type=script&lang=js"
export * from "./ConvalidaModifiche.vue?vue&type=script&lang=js"

import "./ConvalidaModifiche.vue?vue&type=style&index=0&id=1c15b07c&lang=css"
import "./ConvalidaModifiche.vue?vue&type=style&index=1&id=1c15b07c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c15b07c"]])

export default __exports__